export const formatPhone = (phoneNumber): string => {
  const pattern = /(\d{3})(\d{3})(\d{4})/;

  if (!phoneNumber) {
    return '';
  }

  if (!phoneNumber.match(pattern)) {
    return 'Invalid phone number';
  }

  return phoneNumber.match(pattern).slice(1, 4).join('-');
};

export const formatPhoneParenthesis = (phoneNumber): string => {
  const pattern = /(\d{3})(\d{3})(\d{4})/;

  if (!phoneNumber) {
    return '';
  }
  const phoneNumberOnly = phoneNumber.slice(-10);

  if (!phoneNumberOnly.match(pattern)) {
    return 'Invalid phone number';
  }
  const phoneNumberParts = phoneNumberOnly.match(pattern).slice(1, 4);

  return `(${phoneNumberParts[0]}) ${phoneNumberParts[1]}-${phoneNumberParts[2]}`;
};
